module.exports = __webpack_public_path__ + "static/media/posicao_amamentar3.23aadfaf.jpg";